'use client'

import axios, { type AxiosError, type AxiosResponse } from 'axios'
import useSwr, { type SWRResponse } from 'swr'

import { type TenantLanguage } from '../../../tenant'
import { PARCEL_LAB_BASE_URL } from '../../model/PARCEL_LAB_BASE_URL'
import { type ParcelLabResponse } from '../../model/ParcelLabTypes'

const getParcelLabTrackingUrl = (
  language: TenantLanguage,
  trackingId?: string,
  courier?: string | null,
): string => {
  if (!trackingId || !courier) {
    return ''
  }

  return `${PARCEL_LAB_BASE_URL}?tno=${trackingId}&courier=${courier}&language=${language}`
}

const getParcelLabTrackingSwrKey = (trackingId?: string): string => {
  if (!trackingId) {
    return ''
  }

  return `shippingStatusLastOrder${trackingId}`
}

export const useApiParcelLabSwrGetOrderStatus = (
  language: TenantLanguage,
  trackingId?: string,
  courier?: string | null,
): SWRResponse<ParcelLabResponse, AxiosError> => {
  const url = getParcelLabTrackingUrl(language, trackingId, courier)

  const fetcher = async (): Promise<ParcelLabResponse> => {
    return axios
      .get(url)
      .then((response: AxiosResponse<ParcelLabResponse>) => response.data)
  }

  return useSwr(getParcelLabTrackingSwrKey(trackingId), fetcher)
}
